/* ===========================
   assets/dte-drawer.js
   =========================== */
// Drawer DTE para Shopify Basic: atributos ASCII vía inputs ocultos, RUT con checksum+autoformato,
// radios robustos, CTA bloqueado en "Factura", y SINCRONIZACIÓN en submit del form.

(function () {
  let __running = false;

  window.initDteDrawer = function () {
    if (__running) return;
    __running = true;

    try {
      const root = document.getElementById("dte-drawer");
      const formEl = document.getElementById("dte-form");
      const errEl = document.getElementById("dte-error");
      const drawer = document.getElementById("CartDrawer");
      const cartForm = document.getElementById("CartDrawer-Form");
      const checkoutBtn =
        document.getElementById("CartDrawer-Checkout") ||
        (drawer || document).querySelector('[name="checkout"]');

      if (!root || !formEl || !checkoutBtn || !cartForm) { __running = false; return; }
      if (root.dataset.dteInited === "1") { __running = false; return; }
      root.dataset.dteInited = "1";

      // Radios (tolerante a DOM dinámico)
      const rBoleta = () => document.getElementById("dte-tipo-boleta") || root.querySelector("#dte-tipo-boleta");
      const rFactura = () => document.getElementById("dte-tipo-factura") || root.querySelector("#dte-tipo-factura");

      // Campos
      const F = {
        rut: root.querySelector("#dte-rut"),
        razon: root.querySelector("#dte-razon"),
        dir: root.querySelector("#dte-dir"),
        comuna: root.querySelector("#dte-comuna"),
      };

      // A11y + mensajes inline
      Object.entries(F).forEach(([key, el]) => {
        if (!el) return;
        let msg = el.nextElementSibling;
        if (!msg || !msg.classList || !msg.classList.contains("dte-msg")) {
          msg = document.createElement("small");
          msg.className = "dte-msg";
          msg.id = `dte-msg-${key}`;
          el.setAttribute("aria-describedby", msg.id);
          el.insertAdjacentElement("afterend", msg);
        }
      });

      // Barrera de propagación dentro del root
      ["input","change","keydown","keyup","click"].forEach((evt) => {
        root.addEventListener(evt, (e) => {
          if (!root.contains(e.target)) return;
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          e.stopPropagation();
          if ((evt === "keydown" || evt === "keyup") && e.key === "Enter") e.preventDefault();
        }, true);
      });

      // Utils
      const debounce = (fn, ms = 350) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
      const onlyLetters = (s) => s.replace(/[^A-Za-zÁÉÍÓÚÑáéíóúñ\s]/g, "");
      const stripDigits = (s) => s.replace(/[0-9]/g, "");
      const showGlobalErr = (m) => { if (!errEl) return; errEl.textContent = m || ""; errEl.style.display = m ? "" : "none"; errEl.setAttribute("aria-live","polite"); };

      // Normaliza a [0-9K]
      const normalizeRut = (v) => !v ? "" : v.toString().trim().toUpperCase().replace(/[\s.\u00A0]/g,"").replace(/[—–\-]/g,"").replace(/[^0-9K]/g,"");

      // DV módulo 11
      function rutDV(bodyDigits){ let m=2,sum=0; for(let i=bodyDigits.length-1;i>=0;i--){ sum+=Number(bodyDigits[i])*m; m = m===7?2:m+1; } const r=11-(sum%11); return r===11?"0":r===10?"K":String(r); }
      function isRutValid(v){ const s=normalizeRut(v); if(!/^[0-9]{7,9}[0-9K]$/.test(s)) return false; return rutDV(s.slice(0,-1))===s.slice(-1); }

      // Autoformato RUT + caret
      const MAX_NORM = 10;
      const prettyFromNormalized = (n)=>{ if(!n) return ""; if(n.length<=1) return n; const body=n.slice(0,-1), dv=n.slice(-1); const withDots=body.replace(/\B(?=(\d{3})+(?!\d))/g,"."); return `${withDots}-${dv}`; };
      const mapRawPosToPretty = (pretty, rawPos)=>{ let c=0; for(let i=0;i<pretty.length;i++){ if(/[0-9K]/.test(pretty[i])){ if(c===rawPos) return i; c++; } } return pretty.length; };
      function formatRutInput(el){
        const prevVal = el.value;
        const prevCaret = el.selectionStart || 0;
        const rawBefore = normalizeRut(prevVal.slice(0, prevCaret));
        const n = normalizeRut(prevVal).slice(0, MAX_NORM);
        const pretty = prettyFromNormalized(n);
        el.value = pretty;
        const newCaret = mapRawPosToPretty(pretty, rawBefore.length);
        try { el.setSelectionRange(newCaret, newCaret); } catch(_) {}
      }
      if (F.rut) F.rut.setAttribute("maxlength","12");

      // Hidden attributes (ASCII) — garantiza llegada al pedido
      function ensureHiddenAttr(key){
        const id = "dte-attr-"+key.toLowerCase().replace(/\s+/g,"-").replace(/[^\w\-]/g,"");
        let el = document.getElementById(id);
        if (!el){
          el = document.createElement("input");
          el.type = "hidden"; el.id = id; el.name = `attributes[${key}]`;
          cartForm.appendChild(el);
        }
        return el;
      }
      const HA = {
        tipo:  ensureHiddenAttr("Tipo de documento"),
        rut:   ensureHiddenAttr("RUT"),
        razon: ensureHiddenAttr("Razon Social"),
        dir:   ensureHiddenAttr("Direccion"),
        comuna:ensureHiddenAttr("Comuna"),
      };
      function syncHiddenAttrs(){
        const tipo = currentTipo() || "Boleta";
        HA.tipo.value = tipo;
        if (tipo === "Factura"){
          HA.rut.value   = isRutValid(F.rut?.value) ? normalizeRut(F.rut.value) : "";
          HA.razon.value = (F.razon?.value || "").trim();
          HA.dir.value   = (F.dir?.value || "").trim();
          HA.comuna.value= (F.comuna?.value || "").trim();
        } else {
          HA.rut.value = HA.razon.value = HA.dir.value = HA.comuna.value = "";
        }
      }

      // Guardado asincrónico (extra)
      async function saveAttributes(partial){
        try{
          await fetch("/cart/update.js", {
            method:"POST",
            headers:{ "Content-Type":"application/json" },
            keepalive:true,
            body: JSON.stringify({ attributes: partial })
          });
        }catch(_){}
      }
      function saveAttributesReliable(partial){
        try{
          const blob = new Blob([JSON.stringify({ attributes: partial })], { type:"application/json" });
          if (navigator.sendBeacon){ navigator.sendBeacon("/cart/update.js", blob); return; }
        }catch(_){}
        saveAttributes(partial);
      }
      const saveDebounced = debounce(saveAttributes, 400);

      function currentTipo(){ if (rBoleta()?.checked) return "Boleta"; if (rFactura()?.checked) return "Factura"; return ""; }
      function toggleForm(){ formEl.style.display = currentTipo()==="Factura" ? "" : "none"; }

      function setBoletaMode(){
        root.classList.remove("dte-box--pending");
        formEl.style.display = "none";
        checkoutBtn.removeAttribute("disabled"); checkoutBtn.removeAttribute("title"); checkoutBtn.removeAttribute("aria-disabled");
        checkoutBtn.style.opacity = ""; checkoutBtn.style.pointerEvents = "";
        ["rut","razon","dir","comuna"].forEach(k=>{
          const el = F[k]; if (!el) return;
          el.classList.remove("is-invalid","is-valid"); el.removeAttribute("aria-invalid");
          const m = el.parentElement?.querySelector(".dte-msg") || el.nextElementSibling;
          if (m?.classList?.contains("dte-msg")){ m.textContent=""; m.style.visibility="hidden"; }
        });
        showGlobalErr(""); syncHiddenAttrs();
      }

      function setFieldState(el, ok, msg, { force=false } = {}){
        if (!el) return;
        const touched = el.dataset.touched === "1" || force;
        el.classList.toggle("is-invalid", !ok && touched);
        el.classList.toggle("is-valid",   ok && touched);
        if (touched) el.setAttribute("aria-invalid", String(!ok));
        const m = el.parentElement?.querySelector(".dte-msg") || el.nextElementSibling;
        if (m?.classList?.contains("dte-msg")){
          m.textContent = (!ok && touched) ? (msg || "") : "";
          m.style.visibility = (!ok && touched) ? "visible" : "hidden";
        }
      }

      function validateFields({ force=false } = {}){
        let ok = true;

        const vrutRaw = (F.rut?.value || "").trim();
        const vrutOk  = isRutValid(vrutRaw);
        if (!vrutRaw){ ok=false; setFieldState(F.rut,false,"RUT (sin puntos ni guion).",{force}); }
        else if (!vrutOk){ ok=false; setFieldState(F.rut,false,"RUT invalido (verifica digito verificador).",{force}); }
        else { setFieldState(F.rut,true,"",{force}); }

        const vraz = stripDigits(F.razon?.value || "").trim();
        if (F.razon && F.razon.value !== vraz) F.razon.value = vraz;
        if (!vraz){ ok=false; setFieldState(F.razon,false,"Razon Social (solo letras).",{force}); }
        else if (vraz.length>60){ ok=false; setFieldState(F.razon,false,"Max. 60 caracteres.",{force}); }
        else { setFieldState(F.razon,true,"",{force}); }

        const vdir = (F.dir?.value || "").trim();
        if (!vdir){ ok=false; setFieldState(F.dir,false,"Ingresa la direccion.",{force}); }
        else if (vdir.length>60){ ok=false; setFieldState(F.dir,false,"Max. 60 caracteres.",{force}); }
        else { setFieldState(F.dir,true,"",{force}); }

        const vcom = onlyLetters(F.comuna?.value || "").trim();
        if (F.comuna && F.comuna.value !== vcom) F.comuna.value = vcom;
        if (!vcom){ ok=false; setFieldState(F.comuna,false,"Comuna (solo letras).",{force}); }
        else if (vcom.length>30){ ok=false; setFieldState(F.comuna,false,"Max. 30 caracteres.",{force}); }
        else { setFieldState(F.comuna,true,"",{force}); }

        return ok;
      }

      function reflectState(){
        const tipo = currentTipo();
        if (tipo !== "Factura"){ setBoletaMode(); return; }
        let pending=false, disable=false, title="";
        const ok = validateFields(); // bloquea CTA aun sin tocar
        if (!ok){ pending=true; disable=true; title="Faltan datos o hay errores en el formulario."; }

        root.classList.toggle("dte-box--pending", pending);
        if (disable){
          checkoutBtn.setAttribute("disabled","true");
          checkoutBtn.setAttribute("aria-disabled","true");
          checkoutBtn.setAttribute("title",title);
          checkoutBtn.style.opacity="0.6"; checkoutBtn.style.pointerEvents="none";
        }else{
          checkoutBtn.removeAttribute("disabled"); checkoutBtn.removeAttribute("aria-disabled"); checkoutBtn.removeAttribute("title");
          checkoutBtn.style.opacity=""; checkoutBtn.style.pointerEvents="";
        }
        syncHiddenAttrs();
      }

      const markTouched = (el)=>{ if (el) el.dataset.touched = "1"; };

      function onAnyInput(){
        if (currentTipo() !== "Factura") return;
        reflectState(); syncHiddenAttrs();
        const attrs = {};
        if (F.rut && isRutValid(F.rut.value)) attrs["RUT"] = normalizeRut(F.rut.value);
        if (F.razon && F.razon.value.trim()) attrs["Razon Social"] = F.razon.value.trim();
        if (F.dir && F.dir.value.trim()) attrs["Direccion"] = F.dir.value.trim();
        if (F.comuna && F.comuna.value.trim()) attrs["Comuna"] = F.comuna.value.trim();
        if (Object.keys(attrs).length) saveDebounced(attrs);
      }

      // Listeners campos
      Object.values(F).forEach((el) => {
        if (!el) return;
        el.addEventListener("input", () => { if (el===F.rut) formatRutInput(el); markTouched(el); onAnyInput(); });
        el.addEventListener("blur",  () => { if (el===F.rut) formatRutInput(el); markTouched(el); reflectState(); });
      });

      // Default inicial: Boleta. Luego respetar persistido.
      const rb0 = rBoleta(); if (rb0) rb0.checked = true; setBoletaMode();

      // Radios
      function handleTipoChange(){
        const tipoSel = currentTipo() || "Boleta";
        syncHiddenAttrs(); saveAttributes({ "Tipo de documento": tipoSel });
        if (tipoSel === "Boleta") setBoletaMode(); else { toggleForm(); reflectState(); }
      }
      function bindTipoListeners(){
        const rb=rBoleta(), rf=rFactura(); let bound=false;
        if (rb && !rb.dataset.dteBound){ rb.addEventListener("change",handleTipoChange,true); rb.addEventListener("input",handleTipoChange,true); rb.dataset.dteBound="1"; bound=true; }
        if (rf && !rf.dataset.dteBound){ rf.addEventListener("change",handleTipoChange,true); rf.addEventListener("input",handleTipoChange,true); rf.dataset.dteBound="1"; bound=true; }
        return bound;
      }
      bindTipoListeners();
      document.addEventListener("change",(e)=>{ const t=e.target; if (t && t.type==="radio" && (t.id==="dte-tipo-boleta"||t.id==="dte-tipo-factura")) handleTipoChange(); }, true);
      const mo = new MutationObserver(()=>{ const nb = bindTipoListeners(); if (nb && rBoleta() && rFactura()) mo.disconnect(); });
      mo.observe(document.documentElement,{ childList:true, subtree:true });

      // Precarga
      fetch("/cart.js").then(r=>r.json()).then(async cart=>{
        const a = cart.attributes || {};
        const tipo = a["Tipo de documento"] || "Boleta";
        if (tipo === "Factura") rFactura() && (rFactura().checked = true); else rBoleta() && (rBoleta().checked = true);

        if (tipo === "Factura"){
          if (F.rut)   F.rut.value   = prettyFromNormalized(normalizeRut(a["RUT"]||""));
          if (F.razon) F.razon.value = a["Razon Social"] || "";
          if (F.dir)   F.dir.value   = a["Direccion"] || "";
          if (F.comuna)F.comuna.value= a["Comuna"] || "";
          toggleForm(); reflectState();
        } else {
          await saveAttributes({ "Tipo de documento":"Boleta" });
          setBoletaMode();
        }
        syncHiddenAttrs();
      }).catch(()=>{ rBoleta()&&(rBoleta().checked=true); setBoletaMode(); syncHiddenAttrs(); });

      // === Punto crítico: sincronizar en SUBMIT del form ===
      cartForm.addEventListener("submit", (e)=>{
        syncHiddenAttrs(); // asegura valores en el POST real
        if (currentTipo() === "Factura"){
          const ok = validateFields({ force:true });
          if (!ok){
            e.preventDefault();
            reflectState();
            showGlobalErr("Corrige los campos marcados en rojo.");
            return;
          }
          // redundante, pero robusto ante flujos ajax
          saveAttributesReliable({
            "Tipo de documento":"Factura",
            "RUT": normalizeRut(F.rut.value),
            "Razon Social": (F.razon.value||"").trim(),
            "Direccion": (F.dir.value||"").trim(),
            "Comuna": (F.comuna.value||"").trim(),
          });
        } else {
          saveAttributesReliable({ "Tipo de documento":"Boleta" });
        }
      });

      // (Opcional) aún dejamos el click por compatibilidad con temas raros
      checkoutBtn.addEventListener("click", ()=>{ syncHiddenAttrs(); });

    } finally { __running = false; }
  };
})();
